import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import { ModalPanel } from '@els/els-react--modal-panel';
import InnerHTML from '@Components/InnerHTML';
import {
  CONDITIONS_DRAW_EXAMPLES,
  CONDITIONS_LEARN_DRAWING_TIPS,
  CONDITIONS_LEARN_HOW_IT_WORKS_STEPS,
  CONDITIONS_LEARN_WHAT_YOU_WILL_SEE,
} from '../constants';

function ConditionsLearnPanel({ onClose, onExampleClick = () => {} }) {
  return (
    <ModalPanel panelPosition="right" panelSize="medium" modalProps={{ onClose, label: 'Learn how it works' }}>
      <div className="conditions-learn-panel u-els-padding-1o2" data-e2e="conditions-learn-panel">
        <h2 className="u-els-padding-bottom">Learn how it works</h2>

        <h3 className="u-els-font-family-bold u-els-padding-bottom">Introducing Reaxys Conditions Navigator</h3>
        <p className="u-els-padding-bottom">
          <b>Find literature-backed reaction conditions from similar reactions - all in one decision-ready view.</b>
        </p>

        <h3 className="u-els-font-family-bold u-els-padding-bottom">How it works</h3>
        <ol className="c-els-list u-els-padding-bottom">
          {CONDITIONS_LEARN_HOW_IT_WORKS_STEPS.map((step) => (
            <li className="c-els-list__item" key={step}>
              {step}
            </li>
          ))}
        </ol>

        <h3 className="u-els-font-family-bold u-els-padding-bottom">Drawing tips</h3>
        <ul className="c-els-list u-els-padding-bottom">
          {CONDITIONS_LEARN_DRAWING_TIPS.map((tip) => (
            <li className="c-els-list__item" key={tip}>
              {tip}
            </li>
          ))}
        </ul>

        <h3 className="u-els-font-family-bold u-els-padding-bottom">Try these examples: </h3>
        <ul className="c-els-list u-els-padding-bottom">
          {CONDITIONS_DRAW_EXAMPLES.map((example) => (
            <li className="c-els-list__item" key={example.key}>
              <Button
                type="link"
                linkOptions={['inline']}
                data-e2e={`conditions-learn-example-${example.key}`}
                onClick={() => onExampleClick(example)}>
                {example.label}
              </Button>
            </li>
          ))}
        </ul>

        <h3 className="u-els-font-family-bold u-els-padding-bottom">What you&rsquo;ll see</h3>
        <ul className="c-els-list">
          {CONDITIONS_LEARN_WHAT_YOU_WILL_SEE.map((item) => (
            <InnerHTML tag="li" className="c-els-list__item" key={item} html={item} />
          ))}
        </ul>
      </div>
    </ModalPanel>
  );
}

ConditionsLearnPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  /** Called with the picked entry of CONDITIONS_DRAW_EXAMPLES. Defaults to a no-op. */
  onExampleClick: PropTypes.func,
};

export default ConditionsLearnPanel;
